import colors from "../../../../appConfig/colors";
import { makeStyles } from "@material-ui/core/styles";

const CurrentAssessmentStyle = makeStyles((theme) => ({
	card: {
		borderRadius: 12,
		boxShadow: `0 2px 8px ${colors.subtleShadow}`,
		background: colors.white,
		transition: "all 0.3s ease",
		marginTop: 30,
		"&:hover": {
			boxShadow: `0 6px 20px ${colors.darkShadowAlpha}`,
			transform: "translateY(-2px)",
		},
	},
	cardHeader: {
		background: colors.whiteSmoke,
		borderBottom: `1px solid ${colors.lightGray}`,
	},
	progressTypography: {
		textAlign: "right",
		marginTop: 6,
	},

	progressBar: {
		height: 10,
		borderRadius: 5,
	},
	button: {
		background: colors.primary,
		color: colors.white,
		fontWeight: 600,
		borderRadius: 8,
		width: "220px",
		textTransform: "none",
		"&:hover": {
			backgroundColor: colors.darkCrimsonRed,
		},
	},
	assessmentStatus: {
		color: colors.primary,
		fontWeight: 600,
	},
	buttonLoading: {
		color: colors.white,
	},
	actionContainer: {
		marginTop: 12,
	},
}));

export default CurrentAssessmentStyle;
